// extracted by mini-css-extract-plugin
module.exports = {"slide":"slide_slide__HaGCS"};